'use client';
import { LayoutType } from '@sbercloud/uikit-product-utils';
import { useEffect, useState } from 'react';

import { CssBreakPoints } from '@/types/common';
import { findBreakPointName } from '@/utils/layout';

export function useLayoutType(breakPoints: CssBreakPoints): LayoutType | null;
export function useLayoutType(breakPoints: CssBreakPoints, initialState: LayoutType): LayoutType;

export function useLayoutType(breakPoints: CssBreakPoints, initialState?: LayoutType) {
  const [layoutType, setLayoutType] = useState<LayoutType | null>(initialState ?? null);

  useEffect(() => {
    const updateLayoutType = () => setLayoutType(findBreakPointName(breakPoints));
    window.addEventListener('resize', updateLayoutType);
    return () => {
      window.removeEventListener('resize', updateLayoutType);
    };
  }, [breakPoints]);

  return layoutType;
}
